function breadcrumbs() {
  const el = document.querySelector('.js-breadcrumbs');

  if (!el) return;

  const items = el.querySelectorAll('.breadcrumbs__item');
  const ellipsis = el.querySelector('.breadcrumbs__ellipsis');

  if (items.length <= 2) {
    return ellipsis.parentNode.removeChild(ellipsis);
  }

  const penultimate = items[items.length - 2];
  const url = penultimate.querySelector('a').getAttribute('href');
  const anchorLink = document.createElement('a');

  anchorLink.setAttribute('href', url);
  anchorLink.innerText = '...';
  ellipsis.appendChild(anchorLink);
}
breadcrumbs();
